<ng-container>

  <div class="StatsCard mb-12px" oneConfetti *ngIf="stats?.total_revenue as total_revenue" [totalCount]="total_revenue">
    <div class="StatsCard-Hero">
      {{ 'upsell_cards.one_upsell_made' | transloco }}
      <span class="text-primary conveythis-no-translate">{{(total_revenue | currency : userCurrency : 'symbol' : '1.2-2') || 0}}</span>
    </div>
    <pf-loading-overlay
      [filter]="{only: ['UpsellStats']}"
      [isFixed]='false'
      class='loading-overlay'
    ></pf-loading-overlay>
  </div>

  <div class='_local-upsell-stats'>
    <div class='StatsCard'>
      <one-icon class="StatsCard-Tooltip" name="help-circle-outline" [matTooltip]="'upsell_cards.tooltip_views' | transloco"
         matTooltipClass="Tooltip-Box" matTooltipPosition="above"></one-icon>
      <div class='StatsCard-Title'>
        {{ 'upsell_cards.views' | transloco }}
      </div>
      <div class='StatsCard-Value conveythis-no-translate' *ngIf="stats && !stats?.loading">
        {{(stats?.views || 0) | number}}
        <pf-loading-overlay
          [filter]="{only: ['UpsellStats']}"
          [isFixed]='false'
          class='loading-overlay'
        ></pf-loading-overlay>
      </div>
    </div>

    <div class='StatsCard'>
      <one-icon class="StatsCard-Tooltip" name="help-circle-outline" [matTooltip]="'upsell_cards.tooltip_conversions' | transloco"
         matTooltipClass="Tooltip-Box" matTooltipPosition="above"></one-icon>
      <div class='StatsCard-Title'>
        {{ 'upsell_cards.conversions' | transloco }}
      </div>
      <div class='StatsCard-Value conveythis-no-translate' *ngIf="stats && !stats?.loading">
        {{(stats?.conversions || 0) | number}}
        <pf-loading-overlay
          [filter]="{only: ['UpsellStats']}"
          [isFixed]='false'
          class='loading-overlay'
        ></pf-loading-overlay>
      </div>
    </div>

    <div class='StatsCard'>
      <one-icon class="StatsCard-Tooltip" name="help-circle-outline" [matTooltip]="'upsell_cards.tooltip_conversion_rate' | transloco"
        matTooltipClass="Tooltip-Box" matTooltipPosition="above"></one-icon>
      <div class='StatsCard-Title'>
        {{ 'upsell_cards.conversion_rate' | transloco }}
      </div>
      <div class='StatsCard-Value conveythis-no-translate' *ngIf="stats && !stats?.loading">
        {{(stats?.conversion_rate | percent) || '0%'}}
        <pf-loading-overlay
          [filter]="{only: ['UpsellStats']}"
          [isFixed]='false'
          class='loading-overlay'
        ></pf-loading-overlay>
      </div>
    </div>

    <div class='StatsCard'>
      <one-icon class="StatsCard-Tooltip" name="help-circle-outline" [matTooltip]="'upsell_cards.tooltip_aov' | transloco"
        matTooltipClass="Tooltip-Box" matTooltipPosition="above"></one-icon>
      <div class='StatsCard-Title'>
        {{ 'upsell_cards.aov' | transloco }}
      </div>
      <div class='StatsCard-Value conveythis-no-translate' *ngIf="stats && !stats?.loading">
        {{(stats?.average_order | currency:userCurrency:'symbol':'1.2-2') || 0}}
        <pf-loading-overlay
        [filter]="{only: ['UpsellStats']}"
        [isFixed]='false'
        class='loading-overlay'
        ></pf-loading-overlay>
      </div>
      <small *ngIf="stats?.average_increase_rate > 0" class="upsell-stats-subtitle">
        <span class="_local-highlight"><span class="conveythis-no-translate">+{{ stats?.average_increase_rate | percent}}</span> {{ 'upsell_cards.higher' | transloco }}</span>
        {{ 'upsell_cards.compared_to_previous' | transloco }}
      </small>
    </div>
  </div>
</ng-container>
